export default "__VITE_ASSET__00ee6c78__"